import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Analytics } from '@vercel/analytics/react';
import './App.css';
import StoryReader from './components/StoryReader';
import Feed from './components/Feed';
import PrivacyPolicy from './components/PrivacyPolicy';
import ExternalRedirect from './components/ExternalRedirect';

// Component to update metadata based on the current route
function RouteMetadata() {
  const location = useLocation();
  
  useEffect(() => {
    // Get the domain for absolute URLs
    const domain = window.location.protocol + '//' + window.location.host;
    
    // Default metadata
    let title = "Sunny Sideup Storys (Insta: @sunnysideup_storys)";
    let description = "Immersive Indian horror fiction short stories with ambient soundscapes. A new way to experience horror!";
    let image = "/assets/Logo-small.PNG";
    
    // Route-specific metadata
    if (location.pathname === "/barfi-bazaar") {
      title = "The Night Guests of Barfi Bazaar | Sunny Sideup Storys";
      description = "A terrifying fictional tale of the strange guests that visit the vendors of a vibrant Indian sweets market. Experience the sights, sounds, and chills of the traditional barfi bazaar.";
      image = "/assets/story-images/story1.3-small.JPEG";
    } else if (location.pathname === "/privacy") {
      title = "Privacy Policy | Sunny Sideup Storys";
      description = "Learn about how we protect your privacy and handle your data.";
    } else if (location.pathname === "/data-deletion") {
      title = "Data Deletion | Sunny Sideup Storys";
      description = "Request deletion of your personal data from our systems.";
    }
    
    // Construct absolute URLs for images
    const absoluteImageUrl = domain + image;
    
    // Update meta tags
    document.title = title;
    
    // Static meta tags to update with prerendered content
    const staticMetaTags = [
      { selector: 'meta[property="og:title"]', attr: 'content', value: title },
      { selector: 'meta[property="og:description"]', attr: 'content', value: description },
      { selector: 'meta[property="og:image"]', attr: 'content', value: absoluteImageUrl },
      { selector: 'meta[property="twitter:title"]', attr: 'content', value: title },
      { selector: 'meta[property="twitter:description"]', attr: 'content', value: description },
      { selector: 'meta[property="twitter:image"]', attr: 'content', value: absoluteImageUrl }
    ];
    
    // Update the existing meta tags
    staticMetaTags.forEach(tag => {
      const element = document.querySelector(tag.selector);
      if (element) {
        element.setAttribute(tag.attr, tag.value);
      }
    });
    
    // Add a special meta tag to help debugging
    let debugTag = document.querySelector('meta[name="route-debug"]');
    if (!debugTag) {
      debugTag = document.createElement('meta');
      debugTag.setAttribute('name', 'route-debug');
      document.head.appendChild(debugTag);
    }
    debugTag.setAttribute('content', `Route: ${location.pathname}, Image: ${absoluteImageUrl}, Time: ${new Date().toISOString()}`);
    
  }, [location]);
  
  return null; // This component doesn't render anything
}

function AppRoutes() {
  return (
    <>
      <RouteMetadata />
      <Routes>
        <Route path="/feed" element={<Feed />} />
        <Route path="/story/:storyId" element={<StoryReader />} />
        <Route path="/barfi-bazaar" element={<StoryReader />} />
        <Route path="/" element={<Feed />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/data-deletion" element={<PrivacyPolicy />} />
        <Route path="/open-external" element={<ExternalRedirect />} />
      </Routes>
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppRoutes />
        <Analytics />
      </BrowserRouter>
    </div>
  );
}

export default App;
